import { Directive, DOCUMENT, ElementRef, inject, Input } from '@angular/core'

import { AnalyticsService } from 'app/core/analytics/analytics.service'
import { AnalyticsEvent } from 'app/core/analytics/analytics-event.enum'
import { PreconnectLinkService } from 'app/core/preconnect-link.service'

@Directive()
export abstract class LazyVideoComponent {
  @Input() videoId: string

  abstract readonly placeholderImageSrcUrl: string
  abstract readonly videoType: string
  protected placeholder = true

  protected readonly element: HTMLElement = inject(ElementRef).nativeElement
  protected readonly doc: Document = inject(DOCUMENT)
  protected readonly preconnectLinkService = inject(PreconnectLinkService)
  private readonly analytics = inject(AnalyticsService)

  protected abstract warmup(): void

  protected abstract initIframe(iframeEl: HTMLIFrameElement): void

  protected activate(): void {
    this.placeholder = false
    this.appendIframe()
    this.analytics.trackEvent(AnalyticsEvent.VIDEO_PLAYED, { video: this.videoId, player: this.videoType })
  }

  private appendIframe() {
    const iframeEl = this.doc.createElement('iframe')
    iframeEl.title = `${this.videoType} video`
    this.initIframe(iframeEl)
    this.element.append(iframeEl)
    iframeEl.focus()
  }
}
